import { Selecting, useToastProvider } from '@qualio/ui-components';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { DocumentStatus } from '../../../../../../../../api/model/document';
import { useTableDataInvalidation } from '../../../../hooks/useTableDataInvalidation';
import { WorkspaceTabs } from '../../../../WorkspaceV2';
import {
  hasAllowedStatusesForAction,
  hasRequiredPermissionsForAction,
  isValidTabForAction,
} from '../../../BulkActions';
import { BulkActionButton } from '../../BulkActionButton/index';
import { handleStatusChange } from '../ChangeStatusService';
import {
  ChangeStatusButtonProps,
  IsChangeStatusActionAllowedCallback,
} from '../types';

export const SendForReviewButton = (props: ChangeStatusButtonProps) => {
  const { t } = useTranslation();
  const { showToast } = useToastProvider();
  const [isLoading, setIsLoading] = useState(false);
  const { selectedDocuments } = props;
  const selection = Selecting.useSelectionMaybe();
  const { invalidate } = useTableDataInvalidation();
  const toastActionStringActive = t('buttons.sendForReview').toLowerCase();
  const toastActionStringPassive = t('notifications.sentForReview')
    .toLowerCase()
    .replace('!', '');

  const handleSendForReview = async () => {
    setIsLoading(true);
    await handleStatusChange(
      selectedDocuments,
      { status: DocumentStatus.For_Review },
      selection?.setSelection as any,
      showToast,
      toastActionStringActive,
      toastActionStringPassive,
    );
    setIsLoading(false);
    void invalidate(props.currentTab);
  };

  const canSendForReview: IsChangeStatusActionAllowedCallback = (
    user,
    statuses,
    activeTab,
    requiredPermissions,
  ) => {
    if (
      !hasRequiredPermissionsForAction(requiredPermissions, user.permissions) ||
      !isValidTabForAction([WorkspaceTabs.YOUR_DOCUMENTS], activeTab)
    ) {
      return false;
    }
    return hasAllowedStatusesForAction([DocumentStatus.Draft], statuses);
  };

  return (
    <BulkActionButton
      {...props}
      isActionAllowed={canSendForReview}
      onClick={handleSendForReview}
      isLoading={isLoading}
    />
  );
};
